import React, { useLayoutEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TablePagination from "@mui/material/TablePagination";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { getArticleStatusStyle } from "../../../../utils/articlesHelpers";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../../../dashboardcomponents/Traffic/NoDataFound";

export default function ReviewQueueTable({
  rows,
  page,
  rowsPerPage,
  onChangePage,
  totalCount,
  highlightArticleId,
  onHighlightConsumed,
}) {
  const navigate = useNavigate();
  const visibleRows = rows;

  useLayoutEffect(() => {
    if (!highlightArticleId || !visibleRows.length) return;
    const id = String(highlightArticleId);
    const match = visibleRows.some((r) => String(r.id) === id);
    if (!match) return;
    const el = document.getElementById(`review-queue-row-${id}`);
    if (el) {
      el.scrollIntoView({ block: "center", behavior: "smooth" });
      onHighlightConsumed?.();
    }
  }, [highlightArticleId, visibleRows, onHighlightConsumed]);

  return (
    <Box sx={{ mt: 0, display: 'flex', flexDirection: 'column', height: '100%' }}>
      <TableContainer sx={{
        boxShadow: "none",
        flex: 1,
        marginTop: "2px",
        overflowY: "auto",
      }}>
        <Table stickyHeader sx={{ minWidth: 'fit-content' }}>
          <TableHead>
            <TableRow sx={{
              bottom: 0,
              '& th': {
                color: '#405261',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 400,
                paddingTop: '0px',
                paddingBottom: '0px',
              },
            }}>
              <TableCell sx={{ paddingBottom: '9px !important', paddingLeft: 0, minWidth: '658px', }}>
                Articles
              </TableCell>
              <TableCell sx={{ minWidth: '174px', paddingBottom: '9px !important', paddingLeft: '16px' }}>
                Status
              </TableCell>
              <TableCell sx={{ paddingBottom: '9px !important', paddingLeft: '16px' }}>
                Contributor
              </TableCell>
              <TableCell sx={{ paddingBottom: '9px !important', paddingLeft: '16px', paddingRight: '27px' }}>
                Date Submitted
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows.map((row, idx) => {
              const isHighlighted =
                highlightArticleId &&
                String(row.id) === String(highlightArticleId);
              return (
              <TableRow
                key={row.id}
                id={`review-queue-row-${row.id}`}
                sx={{
                  height: '64px',
                  cursor: 'pointer',
                  backgroundColor: isHighlighted ? '#F3FBFF' : undefined,
                  '&:hover': {
                    backgroundColor: isHighlighted ? '#E8F6FE' : '#F7F8F9',
                  },
                  '& td': {


                    paddingBottom: idx === visibleRows.length - 1 ? '16px' : '12px',
                  }
                }}
                onClick={() => navigate(`/kb/article/${row.id}`, { state: { fromReviewQueue: true } })}
              >
                <TableCell sx={{ minWidth: '658px', paddingLeft: 0 }}>
                  <Typography
                    sx={{
                      color: "#061522",
                      fontSize: 14,
                      fontWeight: 400,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {row.title}
                  </Typography>
                </TableCell>

                <TableCell sx={{ paddingLeft: '16px', minWidth: '174px', }}>
                  <Box sx={getArticleStatusStyle(row.status)}>
                    {row.status === 'pendingReview' ? 'Pending Review' : row.status.charAt(0).toUpperCase() + row.status.slice(1)}
                  </Box>
                </TableCell>

                <TableCell sx={{ paddingLeft: '16px', }}>
                  {row.contributor}
                </TableCell>

                <TableCell padding="none">
                  <Typography
                    sx={{
                      color: '#405261',
                      fontSize: 14,
                      fontWeight: 400,
                      paddingTop: '16px',
                      ml: '16px',
                      paddingRight: '27px !important',
                    }}
                  >
                    {row.dateSubmitted}
                  </Typography>
                </TableCell>
              </TableRow>
            );
            })}
          </TableBody>
        </Table>

        {visibleRows.length === 0 && (
          <NoDataFound containerStyle={{ height: '57vh' }} isForKb={true} title="No review queue found" description="This segment is empty. Try another one or come back later" />
        )}
      </TableContainer>

      {
        totalCount > rowsPerPage && (
          <Box sx={{
            width: '100%',
            background: '#fff',
            borderTop: '1px solid #E5E9EC',
            padding: '16px 24px',
          }}>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={(_, newPage) => onChangePage(newPage)}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[]}
              labelDisplayedRows={({ from, to }) => (
                <Typography sx={{ color: '#405261', fontFamily: 'Inter', fontSize: '14px', fontWeight: 400 }}>
                  Article {from}-{to}
                </Typography>
              )}
              ActionsComponent={(props) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginLeft: 'auto', flexWrap: 'wrap' }}>
                  <Button
                    onClick={(e) => props.onPageChange(e, props.page - 1)}
                    disabled={props.page === 0}
                    sx={{
                      width: { xs: '100px', sm: '128px' },
                      height: '40px',
                      borderRadius: '8px',
                      border: '1px solid #D5DCE1',
                      background: '#FFF',
                      boxShadow: '0px 1px 2px 0px rgba(6, 21, 34, 0.05)',
                      color: '#405261',
                      fontSize: '14px',
                      fontWeight: 500,
                      textTransform: 'none',
                      '&:not(.Mui-disabled):hover': { backgroundColor: '#FFFFFF', borderColor: '#C5CED6' },
                      '&.Mui-disabled': { color: '#93A1B0', border: '1px solid #C5CED6', bgcolor: '#F9FAFA' },
                    }}
                  >
                    Previous
                  </Button>
                  <Button
                    onClick={(e) => props.onPageChange(e, props.page + 1)}
                    disabled={props.page >= Math.ceil(props.count / rowsPerPage) - 1}
                    sx={{
                      width: { xs: '80px', sm: '88px' },
                      height: '40px',
                      borderRadius: '8px',
                      border: '1px solid #D5DCE1',
                      background: '#FFFFFF',
                      boxShadow: '0px 1px 2px 0px rgba(6, 21, 34, 0.05)',
                      color: '#405261',
                      fontSize: '14px',
                      fontWeight: 500,
                      textTransform: 'none',
                      '&:not(.Mui-disabled):hover': { backgroundColor: '#FFFFFF', borderColor: '#C5CED6' },
                      '&.Mui-disabled': { color: '#93A1B0', border: '1px solid #C5CED6', bgcolor: '#F9FAFA' },
                    }}
                  >
                    Next
                  </Button>
                </Box>
              )}
              sx={{
                '.MuiTablePagination-toolbar': {
                  minHeight: 'unset',
                  paddingTop: '0px',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  gap: 1,
                },
                '.MuiTablePagination-spacer': { display: 'none' },
                '.MuiTablePagination-selectLabel': { display: 'none' },
                '.MuiTablePagination-select': { display: 'none' },
                '.MuiTablePagination-selectIcon': { display: 'none' },
              }}
            />
          </Box>
        )
      }
    </Box >
  );
}